import React from 'react';
import { Search, ChevronRight } from 'lucide-react';

// Door pages no longer carry their own listing — every listing lives on
// /all-schools. This is how each door hands off, with its own level already
// selected, so "High Schools" lands you on the directory filtered to secondary
// rather than on 1,654 unfiltered rows.
export const DirectoryLink = ({ setPage, level, label, count, className = '' }) => (
  <button
    onClick={() => setPage('all-schools', level ? { level } : undefined)}
    className={`group w-full flex items-center gap-3.5 p-5 rounded-2xl text-left bg-canvas-raised ring-1 ring-hairline shadow-sm transition-all duration-200 hover:shadow-lg hover:-translate-y-0.5 hover:ring-brand-200 active:scale-[0.99] ${className}`}
  >
    <span className="flex-shrink-0 flex items-center justify-center w-11 h-11 rounded-xl bg-brand-50 ring-1 ring-brand-100 transition-transform duration-200 group-hover:scale-110">
      <Search className="w-5 h-5 text-brand-700" aria-hidden="true" />
    </span>
    <span className="min-w-0 flex-1">
      <span className="block font-bold text-[15px] text-ink leading-tight">{label}</span>
      {count != null && (
        <span className="block text-sm text-ink-muted mt-0.5">
          {count.toLocaleString()} in the Ministry directory — search by name, parish, type or sector
        </span>
      )}
    </span>
    <ChevronRight className="w-5 h-5 flex-shrink-0 text-ink-subtle transition-transform duration-200 group-hover:translate-x-1" aria-hidden="true" />
  </button>
);

export default DirectoryLink;
